import React from 'react'
import { spacesToCamelCase } from '../../utils/toCamelCase'
import { insuranceLayout } from '@/constants/insuranceLayout'
export type MiniCardType = {
  img: string
  title: string
  count: number
  location: string
  slug: string
  bgImage?: string
  showCount?: boolean
  anchorTitle?: string
  insuranceSlug?: string
}

type Props = {
  card: MiniCardType
  onCardClick?: () => void
  labelSize?: 'small' | 'large'
  className?: string
}

const MiniCard = ({
  card: {
    count,
    img,
    title,
    location,
    bgImage,
    showCount = true,
    insuranceSlug,
    anchorTitle
  },
  onCardClick,
  labelSize = 'small',
  className
}: Props): JSX.Element => {
  const backgroundClass = insuranceSlug
    ? insuranceLayout[insuranceSlug]?.style || insuranceLayout.default.style
    : `${spacesToCamelCase(title.toLowerCase().replace(/\(|\)/g, ''))}-bg`
  const labelSizeClass =
    labelSize === 'large' ? 'text-sm md:text-base' : 'text-xs'

  return (
    <div
      className={`group min-w-[124px] cursor-pointer items-center overflow-hidden md:h-[128px] md:min-w-[164px] md:max-w-[164px] ${className}`}
      onClick={onCardClick}
    >
      <div className="relative">
        {bgImage ? (
          <img
            src={bgImage}
            alt={title}
            className={`flex h-[80px] w-full items-center justify-center rounded-xl object-cover md:h-[96px] md:max-h-[96px]`}
          />
        ) : (
          <>
            <div
              className={`flex h-[80px] w-full items-center justify-center rounded-xl md:h-[96px] md:max-h-[96px] ${backgroundClass}`}
            />
            <img
              src={img}
              alt={title}
              title={`Centers Accepting ${title}`}
              className="absolute left-1/2 top-1/2 z-0 h-auto max-h-full w-[80px] -translate-x-1/2 -translate-y-1/2 md:w-[100px]"
            />
          </>
        )}
      </div>
      {anchorTitle ? (
        <div className="mt-2 flex w-full flex-nowrap gap-0.5">
          {showCount && (
            <span className={`shrink ${labelSizeClass} text-gray-1100`}>
              {count}
            </span>
          )}
          <span className={`truncate ${labelSizeClass} text-gray-1100`}>
            {anchorTitle}
          </span>
        </div>
      ) : (
        <div className="mt-2 flex w-full flex-nowrap gap-0.5">
          <span className={`truncate ${labelSizeClass} text-gray-1100`}>
            {location}
          </span>
          {showCount && (
            <span className={`shrink ${labelSizeClass} text-gray-1100`}>
              ({count})
            </span>
          )}
        </div>
      )}
    </div>
  )
}

export default MiniCard
